import 'react-datepicker/dist/react-datepicker.css';
import { Button, ButtonToolbar } from 'reactstrap';
import ThaIDLogo from '../../../assets/images/ThaID_logo.png';
import { useDict } from '../../../contexts/LanguageContext';

const ThaIDVerification = (props) => {
    const {
        previousPage,
        onSubmit,
        isLoading,
    } = props;

    const dict = useDict();

    return (
        <div className="thaid_verification_div">
            <div
                className="card__title"
                style={{ marginBottom: '15px' }}
            >
                <h4
                    className="bold-text"
                    style={{ fontSize: '14px' }}
                >
                    {dict.thaIDVerificationTitle}
                </h4>
                <h5
                    className="subhead"
                    style={{ color: '#181818' }}
                >
                    {dict.thaIDVerificationText}
                </h5>
            </div>

            <div className="thaid_logo_container">
                <img src={ThaIDLogo} alt="thaIDLogo" />
            </div>

            <ButtonToolbar className="form__button-toolbar wizard__toolbar justify-content-center">
                <Button
                    color="primary"
                    type="button"
                    className="previous btn-outline-primary btn_uni rounded"
                    onClick={previousPage}
                    data-cy="documentsUpload__backBtn"
                >
                    {dict.back}
                </Button>

                <Button
                    type="button"
                    className={`next btn btn-primary btn_uni rounded ${isLoading && 'disabled'}`}
                    data-cy="documentsUpload__submitBtn"
                    onClick={onSubmit}
                >
                    {dict.verify}
                </Button>
            </ButtonToolbar>
        </div>
    );
};

export default ThaIDVerification;
